module.exports = __webpack_public_path__ + "img/cybo-logo_style2_white.d9881335.svg";